export default "__VITE_PUBLIC_ASSET__b48324f8__"